export const languages = {
  "pt-BR": {
    flagSrc: "assets/flags/brazil_rectangular_icon_with_frame_64.png",
    label: "Português (Brasil)",
  },
  "en-US": {
    flagSrc:
      "assets/flags/united_states_of_america_rectangular_icon_with_frame_64.png",
    label: "English (US)",
  },
  "es-ES": {
    flagSrc: "assets/flags/spain_rectangular_icon_with_frame_64.png",
    label: "Español (España)",
  },
  "fr-FR": {
    flagSrc: "assets/flags/france_rectangular_icon_with_frame_64.png",
    label: "Français",
  },
  "de-DE": {
    flagSrc: "assets/flags/germany_rectangular_icon_with_frame_64.png",
    label: "Deutsch",
  },
  "it-IT": {
    flagSrc: "assets/flags/italy_rectangular_icon_with_frame_64.png",
    label: "Italiano",
  },
  "ru-RU": {
    flagSrc: "assets/flags/russia_rectangular_icon_with_frame_64.png",
    label: "Русский",
  },
  "zh-CN": {
    flagSrc: "assets/flags/china_rectangular_icon_with_frame_64.png",
    label: "中文 (简体)",
  },
  "ja-JP": {
    flagSrc: "assets/flags/japan_rectangular_icon_with_frame_64.png",
    label: "日本語",
  },

  "de-AT": {
    flagSrc: "assets/flags/austria_rectangular_icon_with_frame_64.png",
    label: "Deutsch (Österreich)",
  },
  "el-GR": {
    flagSrc: "assets/flags/greece_rectangular_icon_with_frame_64.png",
    label: "Ελληνικά",
  },
  "hu-HU": {
    flagSrc: "assets/flags/hungary_rectangular_icon_with_frame_64.png",
    label: "Magyar",
  },
  "es-MX": {
    flagSrc: "assets/flags/mexico_rectangular_icon_with_frame_64.png",
    label: "Español (México)",
  },
  "pl-PL": {
    flagSrc: "assets/flags/poland_rectangular_icon_with_frame_64.png",
    label: "Polski",
  },
  "pt-PT": {
    flagSrc: "assets/flags/portugal_rectangular_icon_with_frame_64.png",
    label: "Português (Portugal)",
  },
  "zh-TW": {
    flagSrc:
      "assets/flags/republic_of_china_rectangular_icon_with_frame_64.png",
    label: "中文 (繁體)",
  },
  "ro-RO": {
    flagSrc: "assets/flags/romania_rectangular_icon_with_frame_64.png",
    label: "Română",
  },
  "uk-UA": {
    flagSrc: "assets/flags/ukraine_rectangular_icon_with_frame_64.png",
    label: "Українська",
  },
  "en-GB": {
    flagSrc: "assets/flags/united_kingdom_rectangular_icon_with_frame_64.png",
    label: "English (UK)",
  },
};
